import { OptionLetter, SurveyQuestionType } from "constants/enums/StudentSurveyEnum";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import FileDetail from "./FileDetail";
import SurveyOpenQuestion from "./SurveyOpenQuestion";
import SurveyQuestionOption from "./SurveyQuestionOption";

function SurveyQuestion({
  question,
  answer,
  answerSetter,
  selectedCategory,
  commentSetter,
  questionCommentList,
  questionOrder,
  clearAnswer,
  survey
}) {
  const [questionComment, setQuestionComment] = useState("");

  useEffect(() => {
    checkComment();
  }, [JSON.stringify(question), JSON.stringify(selectedCategory)]);

  const checkComment = () => {
    const isAnswered = questionCommentList
      .filter((_answer) => _answer?.taggedId === selectedCategory?.taggedId)
      .find(
        (_question) =>
          _question?.questionId === question?.id &&
          _question?.branchInfo?.id === selectedCategory?.branch
      );

    if (isAnswered) {
      setQuestionComment(isAnswered?.comment || "");
    } else {
      setQuestionComment("");
    }
  };

  const onBlur = () => {
    commentSetter(question, questionComment);
  };

  const isAnswered = () => {
    return answer?.find(
      (_answer) =>
        _answer?.taggedId === selectedCategory?.taggedId &&
        _answer?.branchInfo?.id === selectedCategory?.branch &&
        _answer.questionId === question?.id
    );
  };

  return (
    <div className="p-5 py-3">
      <div className="row d-flex align-items-center px-4 py-4">
        <div className="d-flex justify-content-center align-items-center mr-1 lms-font-bold bg-light">
          {questionOrder} -
        </div>
        {question?.fileHash && <FileDetail sha={question?.fileHash} />}
        <div className="lms-font-bold">{question?.questionText}</div>
      </div>
      {question?.type === SurveyQuestionType.MULTI_SELECT &&
        question?.options?.map((option, index) => (
          <SurveyQuestionOption
            key={option?.id}
            option={option}
            question={question}
            answer={answer}
            answerSetter={answerSetter}
            selectedPersonnel={selectedCategory}
            letter={OptionLetter[index]}
          />
        ))}

      {question?.type === SurveyQuestionType.OPEN && (
        <SurveyOpenQuestion
          question={question}
          answer={answer}
          answerSetter={answerSetter}
          selectedPersonnel={selectedCategory}
        />
      )}

      {question?.type === SurveyQuestionType.MULTI_SELECT && survey?.surveyQuestionComment && (
        <div className="form-group">
          <label htmlFor="questionComment">
            Bu madde ile ilgili eklemek istediğiniz notunuz var mı?
          </label>
          <textarea
            className="form-control"
            id="questionComment"
            rows="1"
            key={selectedCategory?.taggedId + question?.id + selectedCategory?.branch}
            value={questionComment}
            onChange={(e) => setQuestionComment(e.target.value)}
            onBlur={onBlur}
            type="text"
          ></textarea>
        </div>
      )}

      <div className="d-flex justify-content-end">
        {isAnswered() && (
          <button onClick={() => clearAnswer(question)} className="btn btn-light-danger">
            Seçimi Temizle
          </button>
        )}
      </div>
    </div>
  );
}

export default SurveyQuestion;
